// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2XVBV","col":"styles_col__31h1Y"};